module.exports = __webpack_public_path__ + "static/img/brees-2009-top-image-thumb.8e370be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-top-image-thumb.jpg
// module id = zNpX
// module chunks = 1